// New projects and the project context

export function makeProject(overrides = {}) {
  return {
    id: 'p_' + Date.now(),
    name: '',
    client: '',
    date: '',
    status: 'Planning',
    sections: [],
    expenses: [],
    ...overrides
  };
}
export const ProjectContext = React.createContext(null);
